import React, { useContext, memo } from 'react';
import { Tab } from 'react-bootstrap';
import ChatContentHeader from './ChatContentHeader';
import ChatContentBody from './ChatContentBody';
import MessageTextArea from './MessageTextArea';
import { ChatContext } from 'context/Context';
import PropTypes from 'prop-types';

const ChatContent = ({ setHideSidebar }) => {
  const { threads } = useContext(ChatContext);

  return (
    <Tab.Content className="card-chat-content">
      <ChatContentHeader setHideSidebar={setHideSidebar} />
      {threads.map((thread, index) => (
        <Tab.Pane key={index} eventKey={index} className="card-chat-pane">
          <ChatContentBody thread={thread} />
        </Tab.Pane>
      ))}
      <MessageTextArea />
    </Tab.Content>
  );
};

ChatContent.propTypes = {
  setHideSidebar: PropTypes.func.isRequired
};

export default memo(ChatContent);